import Image from 'next/image';
import { useRouter } from 'next/router';
import { Text, Tag, Box } from '@pairy/pds-react';
import { useState } from 'react';
import { PdfThumbImage } from '@pairy/next-pdf-viewer';

import useFile from '@/hooks/queries/file/useFile';
import { getUTCDate } from '@/utils/getUTCDate';
import NotFoundErrorModal from '@/components/User/_components/common/NotFoundErrorModal';

import FileRelatedButtons from '../FileRelatedButtons';

const PdfInfoWithButtons = () => {
  const router = useRouter();

  const fileId = Number(router.query.fileId);

  const [isNotFoundModalOpen, setIsNotFoundModalOpen] = useState(false);

  const { data: fileData } = useFile(
    {
      fileId,
    },
    {
      enabled: Boolean(fileId),
      select: (data) => data.data.data.file,
      onError: (error) => {
        if (error?.response?.status === 404) {
          setIsNotFoundModalOpen(true);
        }
      },
      retry: 1,
    },
  );

  if (!fileData) {
    return <div />;
  }

  return (
    <>
      <Box
        isTitleImage
        isMultipleCTAButtons
        title={
          fileData.imageSources ? (
            <PdfThumbImage
              thumb={fileData.imageSources.thumb}
              alt={fileData.name}
              fill
              objectFit="cover"
            />
          ) : (
            <Image src={fileData.thumnail} layout="fill" objectFit="cover" />
          )
        }
        bottomCTAButton={
          <FileRelatedButtons
            fileId={fileId}
            fileName={fileData.name}
            fileThumbnail={fileData.thumnail}
          />
        }
      >
        <Text as="p" variant="lg-semibold">
          {fileData.name}
        </Text>
        <Text as="p" variant="sm-medium" color="zinc_400" marginTop={4}>
          {fileData.editedAt
            ? `${getUTCDate(fileData.editedAt, 'yearMonthDay')} 수정됨`
            : `${getUTCDate(fileData.createdAt, 'yearMonthDay')} 생성됨`}
        </Text>
        {fileData.isBulk && (
          <Tag variant="loyalblue_50" marginTop={8} textVariant="md-medium">
            대량발송용
          </Tag>
        )}
      </Box>
      <NotFoundErrorModal
        isModalOpen={isNotFoundModalOpen}
        setModalOpen={setIsNotFoundModalOpen}
      />
    </>
  );
};

export default PdfInfoWithButtons;
